<template>
	<div class="app-container">

		<h1>{{title}}</h1>
		
		<table v-for="(group, i) in diffGroup" :key="i" class="table loading-container">
			<thead>
				<tr>
					<th scope="col">#</th>
					<th scope="col">Key</th>
					<th scope="col">Property</th>
					<th scope="col">Old value</th>
					<th scope="col">New value</th>
					<th scope="col"></th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(g, index) in group" :key="index">
					<td>{{ index + 1 }}</td>
					<td>{{ g.key }}</td>
					<td>{{ g.property }}</td>
					<td>{{ g.oldValue }}</td>
					<td>{{ g.newValue }}</td>
					<td class="text-right">
						<button
							title="Info"
							class="btn btn-secondary"
							@click="view(p)"
						>
							<i class="fas fa-eye"></i>
						</button>
					</td>
				</tr>
			</tbody>
		</table>		
	</div>
</template>
<script>

import {CodeDiff} from 'v-code-diff'

export default {
	name: 'DiffTables',
	components: {
		CodeDiff
	},
	props: {
		diffGroup: [],
        title: String
	},
	data() {
		return {
		
		};
	},
	methods: {
	
		close() {
			this.$emit('close');
		},
	},
};
</script>

<style scoped>
	.h1-buttons.no-verti::after {
		display: none;
	}
	.alert {
		text-align: start;
	}
</style>